module.exports = __webpack_public_path__ + "img/FOG_bg.50e4bc5f.png";